import { Formik } from 'formik';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router';

const Form = ({
  children,
  initialValues,
  onSubmit,
  validationSchema,
  loading,
  defaultActions = true,
}) => {
  const navigate = useNavigate();
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
    >
      {({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          {children}

          {defaultActions && (
            <div className='row my-5'>
              <div className='col-12 my-5 d-flex flex-row justify-content-center'>
                <button
                  onClick={() => navigate(-1)}
                  className='btn f-12 bg-purple mx-2 text-white py-2 d-flex flex-row align-items-center px-3'
                >
                  انصراف
                </button>
                {loading ? (
                  <button className='btn bg-persian-green f-12 text-white py-2 px-3'>
                    <div
                      className='spinner-border text-white spinner-border-sm mb-1'
                      role='status'
                    >
                      <span className='sr-only'></span>
                    </div>
                  </button>
                ) : (
                  <button
                    type='submit'
                    className='btn f-12 bg-persian-green text-white py-2 px-3'
                  >
                    ذخیره اطلاعات
                  </button>
                )}
              </div>
            </div>
          )}
        </form>
      )}
    </Formik>
  );
};

Form.protoType = {
  initialValues: PropTypes.object.isRequired,
  onSubmit: PropTypes?.func,
  validationSchema: PropTypes?.object,
  loading: PropTypes?.bool,
  defaultActions: PropTypes?.bool,
};

export default Form;
